"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingPriceChangeWrapper$ = exports.ListingPriceChangeWrapper$outboundSchema = exports.ListingPriceChangeWrapper$inboundSchema = void 0;
exports.listingPriceChangeWrapperToJSON = listingPriceChangeWrapperToJSON;
exports.listingPriceChangeWrapperFromJSON = listingPriceChangeWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingpricebypropertytype_js_1 = require("./fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingpricebypropertytype.js");
const listingpricebylocality_js_1 = require("./listingpricebylocality.js");
/** @internal */
exports.ListingPriceChangeWrapper$inboundSchema = z.object({
    locality: listingpricebylocality_js_1.ListingPriceByLocality$inboundSchema,
    property_type: z.array(fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingpricebypropertytype_js_1.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceByPropertyType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.ListingPriceChangeWrapper$outboundSchema = z.object({
    locality: listingpricebylocality_js_1.ListingPriceByLocality$outboundSchema,
    propertyType: z.array(fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingpricebypropertytype_js_1.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceByPropertyType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListingPriceChangeWrapper$;
(function (ListingPriceChangeWrapper$) {
    /** @deprecated use `ListingPriceChangeWrapper$inboundSchema` instead. */
    ListingPriceChangeWrapper$.inboundSchema = exports.ListingPriceChangeWrapper$inboundSchema;
    /** @deprecated use `ListingPriceChangeWrapper$outboundSchema` instead. */
    ListingPriceChangeWrapper$.outboundSchema = exports.ListingPriceChangeWrapper$outboundSchema;
})(ListingPriceChangeWrapper$ || (exports.ListingPriceChangeWrapper$ = ListingPriceChangeWrapper$ = {}));
function listingPriceChangeWrapperToJSON(listingPriceChangeWrapper) {
    return JSON.stringify(exports.ListingPriceChangeWrapper$outboundSchema.parse(listingPriceChangeWrapper));
}
function listingPriceChangeWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ListingPriceChangeWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ListingPriceChangeWrapper' from JSON`);
}
//# sourceMappingURL=listingpricechangewrapper.js.map